import { css } from "@emotion/react";

const input = prop => css`
  .MuiInputBase-input {
    @media (max-width: ${prop.theme.screenSizes.mdMax}) {
      height: 51px !important;
      font-size: 16px;
    }
  }
`;

export const addStyles = { input };
